require('./js/cookieconsent.js');

require("./css/homepage.css");
require("./js/homepage.js");
